export const actionTypes = {
  SetSiteInfo: "SetSiteInfo",

};
const initialState = {
  location: {
 
    srl:'',
    siteSrl : '',
    title : '',
    description1 :'',
    description2 :'',
    logo1 :'',
    logo2 : '',
    bpic1 : '',
    bpic2 : '',
    tel1 :'',
    tel2 : '',
    tel3 : '',
    locationAddress : '',
    siteAddress :'',

  }
}
export const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetSiteInfo:

      return { location: action.payload };
    default:
      return state;
  }
};

export const locationActions={

  SetSiteInfo: (location) => ({ type: actionTypes.SetSiteInfo, payload: location }),
  };